import { callVerifyEmail } from "@/api-connector/play-digital-api/metods/account/registration-api";
import { fetchPlayerDetail } from "@/api-connector/play-digital-api/metods/account/account-api";
import { PlayerDetailModel } from "@/api-connector/play-digital-api/models/account-models";
import sazkaAlert from "@/shared/components/sazka-alert/use-sazka-alert";
import { dataLayerRegistrationMailExpired } from "@/data-layer/services/account";
import { parseErrorMessage } from "../utils/user-account-helper";

export async function playerDetailService(): Promise<PlayerDetailModel> {
    try {
        const playerDetail = await fetchPlayerDetail();

        if ((playerDetail.playerPersonalInfo.gender as string) == "M") {
            playerDetail.playerPersonalInfo.gender = "MALE";
        } else if ((playerDetail.playerPersonalInfo.gender as string) == "F") {
            playerDetail.playerPersonalInfo.gender = "FEMALE";
        } else if ((playerDetail.playerPersonalInfo.gender as string) == "U") {
            playerDetail.playerPersonalInfo.gender = "UNSPECIFIED";
        }

        return playerDetail;
    } catch (ex) {
        Promise.reject("Nepodařilo se načíst informace o uživateli.");
    }
}

export async function verifyEmailService(userName: string, token: string) {
    try {
        if (userName && token) {
            await callVerifyEmail(userName, token);
            sazkaAlert("Email úspěšně ověřen");
        }
    } catch (ex: unknown) {
        sazkaAlert(parseErrorMessage(ex, "Při pokusu o ověření emailu došlo k chybě"));
        dataLayerRegistrationMailExpired();
    }
}
